module.exports = __webpack_public_path__ + "img/logo_sselectronic@3x.853a88f1.png";